export const COVERAGES_CONFIG = {
  name: {
    key: "name",
    label: "Nombre",
  },
  type: {
    key: "typeName",
    label: "Tipo de zona",
  },
  productType: {
    key: "productTypeName",
    label: "Tipo de producto",
  }
};

export const COVERAGES_PHRASE = {
  page: {
    table: {
      title: "Catálogo de Cobertura",
      actions: {
        edit: 'Editar',
        delete: 'Eliminar'
      }
    }
  },
  modal: {
    titles: {
      edit: "Modificar Cobertura",
      add: "Agregar Nuevo Cobertura",
      delete: "¿Estás seguro de eliminar esta Cobertura?",
    },
    actions: {
      cancel: "Cancelar",
      add: "Agregar",
      delete: "Eliminar",
      save: "Guardar",
    },
  },
  search: {
    messages: {
      noStations: "No se ha seleccionado alguna planta.",
    },
  },
};
